<template>
	<div>
		<div class="sense-main">
			<div class="sense-search">
				<el-row>
					<el-form label-width="68px">
						<el-col :span="6">
							<el-form-item label="产品类型">
								<el-select size="medium" v-model="searchObj.categoryNo">
									<el-option label="所有产品" value="0"></el-option>
									<el-option label="许可套餐" value="1"></el-option>
									<el-option label="更新次数套餐" value="2"></el-option>
									<el-option label="硬件锁套餐" value="3"></el-option>
								</el-select>
							</el-form-item>		
						</el-col>
						<el-col :span="6">
							<el-form-item label="产品名称">
								<el-input size="medium" v-model.trim="searchObj.productName" maxlength="64"></el-input>
							</el-form-item>	
						</el-col>								
						<el-col :span="9">
							<el-form-item label="扣款时间">
								<el-date-picker size="medium"
									v-model="searchObj.time"
									type="daterange"
									value-format="yyyy-MM-dd"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期" 
									unlink-panels>									
								</el-date-picker>
							</el-form-item>	
						</el-col>
						<el-col :span="3" class="text-right">
							<el-button class="search-btn" size="medium" @click="emptySearch">清空</el-button>
							<el-button class="search-btn" size="medium" type="primary" @click="searchOrderList">搜索</el-button>
						</el-col>									
					</el-form>
				</el-row>
			</div>
			<div class="sense-table-list sense-table-ellipsis">
				<el-table :data="orderListData">					
					<el-table-column prop="orderNo" label="订单编号" min-width="12%" show-overflow-tooltip></el-table-column>
					<el-table-column prop="productName" label="产品名称" min-width="15%" show-overflow-tooltip></el-table-column>
					<el-table-column :formatter="categoryNoFormatter" label="产品类型" min-width="10%"></el-table-column>					
					<el-table-column prop="amount" label="应付金额(元)" min-width="10%"></el-table-column>
					<el-table-column prop="deductAmount" label="实付金额(元)" min-width="10%"></el-table-column>
					<el-table-column :formatter="statusFormatter" label="订单状态" min-width="9%"></el-table-column>
					<el-table-column prop="createAt" label="创建时间" min-width="14%"></el-table-column>
					<el-table-column prop="payAt" label="支付时间" min-width="14%"></el-table-column>
					<el-table-column label="操作" min-width="6%">
						<template slot-scope="scope">
					        <span class="ssicon ss-info operate-icon" title="详情" @click="orderView(scope.row)"></span>
				        </template>
					</el-table-column>			
				</el-table>
			</div>
			<div class="sense-table-pager" v-if="total>0">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10,20,30]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<div class="all-dialog">
			
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {				
				orderListData: [],  //盗版对抗列表数组
				currentPage: 1,  //当前页
				pageSize: 10,  //每页条数
				total: 0,  //数据总数
				searchObj: {
					categoryNo: '0',
					productName: '',
					time: ''
				}	
			}
		},
		methods: {
			getOrderList() {				
				let url = '/order/list.do';

				let param = {
					categoryNo: this.searchObj.categoryNo,
					productName: this.searchObj.productName,
					startTime: this.searchObj.time[0],
					endTime: this.searchObj.time[1],
					currentPage: this.currentPage,
					pageSize: this.pageSize
				};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.orderListData = response.data.rows;
						this.total = response.data.records;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});														
			},
			//查看
			orderView(row) {
				this.$router.push({
	          		path: '/orderDetail',
		            query: {
		            	orderNo: row.orderNo
		            }
	        	})
			},
			//扣款状态formatter
			statusFormatter(row, index) {
				switch(row.status) {
					case 'paid':
						return '扣款成功';
						break;
					case 'unpaid':
						return '未扣款';
						break;
					case 'faild':
						return '扣款失败';
						break;
					case 'insufficient':
						return '余额不足';
						break;
				};
			},
			//产品类型formatter
			categoryNoFormatter(row, index) {
				switch(row.categoryNo) {
					case 0:
						return '所有产品';
						break;
					case 1:
						return '许可套餐';
						break;
					case 2:
						return '更新次数套餐';
						break;
					case 3:
						return '硬件锁套餐';
						break;
				};
			},
			//搜索
			searchOrderList() {
				this.currentPage = 1;
				this.getOrderList();
			},
			//清空
			emptySearch() {
				this.searchObj.categoryNo = '0';
				this.searchObj.productName = '';
				this.searchObj.time = '';
				this.currentPage = 1;
				this.getOrderList();
			},		
			//切换每页显示条数
			handleSizeChange(val) {
				this.pageSize = val;
				this.getOrderList();
			},
			//切换当前页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getOrderList();
			}
		},
		mounted() {
			this.getOrderList();
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// Order.vue?7d1e4f52